import { Directive, forwardRef, Input } from "@angular/core";
import { FormControl, NG_VALIDATORS } from "@angular/forms";

@Directive({
  selector: "[validUrl]",
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ValidUrlDirective),
      multi: true,
    },
  ],
})
export class ValidUrlDirective {
  validator: Function;
  @Input("httpsOnly") httpsOnly: boolean = true;
  constructor() {}

  validate(control: FormControl) {
    if (!control?.value) return null;
    let urlValid = this.httpsOnly
      ? new RegExp(
          `(https://(?:www.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9].[^s]{2,}|www.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9].[^s]{2,}|https://(?:www.|(?!www))[a-zA-Z0-9]+.[^s]{2,}|www.[a-zA-Z0-9]+.[^s]{2,})`
        )
      : new RegExp(
          `(https?://(?:www.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9].[^s]{2,}|www.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9].[^s]{2,}|https?://(?:www.|(?!www))[a-zA-Z0-9]+.[^s]{2,}|www.[a-zA-Z0-9]+.[^s]{2,})`
        );

    let noWhiteSpace = new RegExp(/\s/);
    return urlValid.test(control.value) &&
      !noWhiteSpace.test(control.value.trim())
      ? null
      : {
          urlInvalid: true,
        };
  }
}
